import { combineReducers } from "redux";

import { alert } from "./alert.reducer";
import { authentication } from "./authentication.reducer";
import { content } from "./content.reducer";

const rootReducer = combineReducers({
  alert,
  content,
  authentication,
});

export default rootReducer;
